import * as React from "react";
import {
  OverviewSubtitle,
  OverviewTitle,
  OverviewTitleWithSubtitleWrapper,
  OverviewTitleWrapper,
} from "../../../../components/Details/OverviewInfo/styles";
import { PrimaryButton } from "../../../../components/Forms/Base/Buttons";
import TagsModalForm from "../../../../components/Forms/ConfigCenter/Categories/Tags/ChapterForm/ModalForm";
import TagsTable from "../../../../components/Tables/ConfigCenter/Categories/Tags/FullTable";
import {
  BareLayoutWrapper,
  DetailPageBox,
} from "../../../../components/sharedStyles";
import PageTitle from "../../../Layouts/PageTitle/PageTitle";
import * as SharedStyles from "../../../../components/sharedStyles";

const breadCrumbs = [
  {
    label: "Taggar",
  },
];

export default function TagsOverview() {
  const [createOpen, setCreateOpen] = React.useState(false);

  return (
    <>
      <TagsModalForm
        method="POST"
        isOpen={createOpen}
        onCheckout={() => setCreateOpen(false)}
      />

      <BareLayoutWrapper>
        <SharedStyles.BareLayoutTitleWrapper>
          <PageTitle title="Taggar" breadCrumbs={breadCrumbs} />
        </SharedStyles.BareLayoutTitleWrapper>
        <DetailPageBox>
          <OverviewTitleWrapper>
            <OverviewTitleWithSubtitleWrapper>
              <OverviewTitle>Taggar i systemet</OverviewTitle>
              <OverviewSubtitle>
                Dessa taggar kan sättas på ärenden för att kategorisera dem
              </OverviewSubtitle>
            </OverviewTitleWithSubtitleWrapper>

            <PrimaryButton
              title="Lägg till ny tagg"
              clicked={() => setCreateOpen(true)}
            />
          </OverviewTitleWrapper>

          <TagsTable />
        </DetailPageBox>
      </BareLayoutWrapper>
    </>
  );
}
